module.exports = __webpack_public_path__ + "img/layout_boubel.d28d143d.svg";